export interface IOsiPaymentsWidgetViewModel {
  isLoading: boolean;
  payments: any;
  dateBegin: any;
  dateEnd: any;
  period: any;

  rows: any;

  loadPayments: () => Promise<void>;
  // OSI-808: id строк грида (числовые индексы this.payments) — то, что реально видно
  // пользователю после фильтра/сортировки DataGridPro. Формируется в виджете через apiRef,
  // т.к. это состояние грида, а не VM.
  downloadReport: (visibleRowIds: number[]) => Promise<void>;
}

export const IOsiPaymentsWidgetViewModelToken = Symbol.for('IOsiPaymentsWidgetViewModel');
